import { availablePairs, languages } from "../data/languages";
import type { Course, Language, Level } from "../types/learning";

export function getLanguage(code: string): Language {
  return languages.find((l) => l.code === code) ?? languages[0];
}

export function courseTitle(course: Pick<Course, "target" | "base">): string {
  return `${getLanguage(course.target).name} from ${getLanguage(course.base).name}`;
}

export function targetsFrom(base: string): string[] {
  return availablePairs.find((p) => p.from === base)?.to ?? [];
}

export function basesFor(target: string): string[] {
  return availablePairs.filter((p) => p.to.includes(target)).map((p) => p.from);
}

export function isBaseLanguage(code: string): boolean {
  return availablePairs.some((p) => p.from === code);
}

const levels: Level[] = ["A1", "A2", "B1", "B2", "C1"];
export function nextLevel(level: Level): Level {
  return levels[Math.min(levels.indexOf(level) + 1, levels.length - 1)];
}
